import {useDeferredValue, useMemo, useState} from 'react';

import downloadService from '../../../../services/downloadService';
import logState from '../../../../services/logger/logState';
import {copyToBuffer} from '../../../../utils/bufferUtils';
import LogActionButton from './LogActionButton';
import LogsList from './LogsList';

const LogsTab = () => {
    const [logs, setLogs] = useState(() => logState.getLogState());
    const [filter, setFilter] = useState('');
    const deferredFilter = useDeferredValue(filter);

    const filteredLogs = useMemo(() => {
        if (!logs || !deferredFilter.trim()) return logs;

        const query = deferredFilter.toLowerCase();

        return logs.filter((log) => String(log).toLowerCase().includes(query));
    }, [logs, deferredFilter]);

    const handleClear = () => {
        logState.clearLogState();
        setLogs(null);
        setFilter('');
    };

    const handleCopy = () => {
        const logsToCopy = filteredLogs || logs;

        copyToBuffer(logsToCopy.join('\n'));
    };

    const handleShare = async () => {
        await downloadService.downloadAndShareLogs(filteredLogs || logs);
    };

    return (
        <div className='flex flex-col gap-3'>
            <input
                type='text'
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder='Filter logs...'
                className='text-xs w-full rounded-md bg-gray-100 px-3 py-1.5 text-color-primary outline-none placeholder:text-gray-400 focus:ring-1 focus:ring-color-tertiary'
            />
            <div className='flex gap-2'>
                <LogActionButton onClick={handleClear}>Clear</LogActionButton>
                <LogActionButton onClick={handleCopy}>Copy</LogActionButton>
                <LogActionButton onClick={handleShare}>Share</LogActionButton>
            </div>
            <LogsList logs={filteredLogs} />
        </div>
    );
};

export default LogsTab;
